import { atom } from 'jotai';
import type { PrimitiveAtom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import type { CommittedJobNumberItem, EditingJobNumberItem, JobNumberItem, ScheduleState } from '../types';

export const createEditingJobNumberItem = (): EditingJobNumberItem => ({
  id: crypto.randomUUID(),
  jobNumber: '',
  status: 'editing',
});

export const createCommittedJobNumberItem = (jobNumber: string): CommittedJobNumberItem => ({
  id: crypto.randomUUID(),
  jobNumber,
  status: 'committed',
});

// 取得完了前に参照された場合でも型上安全な空値。実値は createCallSettingsPromise が
// GET /call-settings の取得完了時に store.set で投入する。
const createEmptyScheduleState = (): ScheduleState => {
  const closed = { from: null, to: null };
  const schedule = {
    weekdays: {
      monday: { ...closed },
      tuesday: { ...closed },
      wednesday: { ...closed },
      thursday: { ...closed },
      friday: { ...closed },
      saturday: { ...closed },
      sunday: { ...closed },
    },
    callOnHoliday: false,
    callOnNewYearHolidays: false,
  };
  return { current: schedule, baseline: schedule };
};

// キーはバックエンドの広告コード設定ID（CallSetting.id）。数値IDのため表記揺れによる atom 分裂は起きない。
// 初期化子はキーに依存しないため引数を取らない（型引数でキーの型のみ指定する）。
export const jobNumbersAtomFamily = atomFamily<number, PrimitiveAtom<JobNumberItem[]>>(() => atom<JobNumberItem[]>([]));

export const scheduleAtomFamily = atomFamily<number, PrimitiveAtom<ScheduleState>>(() =>
  atom<ScheduleState>(createEmptyScheduleState())
);

// 仕事Noの追加・削除リクエスト送信中の行ID。useState ではなく atom にすることで、
// 再レンダリング前の連打でも送信処理側が同期的に読めて重複リクエストを防げる。
export const pendingJobNumberIdsAtomFamily = atomFamily<number, PrimitiveAtom<ReadonlySet<string>>>(() =>
  atom<ReadonlySet<string>>(new Set<string>())
);

// スケジュール保存リクエストの送信中フラグ。pendingJobNumberIdsAtomFamily と同じく二重送信防止用。
export const scheduleSavingAtomFamily = atomFamily<number, PrimitiveAtom<boolean>>(() => atom(false));
